import styled from '@themes/theme'
import { SafeAreaConstantPadding, SafeAreaEnvPadding, TxtLimit } from '@styles/base.style'

export const RankingContainer = styled.div`
  position: fixed;
  bottom: 143px;
  right: 12px;
  justify-content: flex-end;
  z-index: 99;
  padding-bottom: ${SafeAreaEnvPadding};
  padding-bottom: ${SafeAreaConstantPadding};
  width: auto;
  &.home-pc {
    position: absolute;
    bottom: 122px;
    right: 26px;
  }
  &.match-tab {
    position: static;
    z-index: 2;
  }
  .ranking-event-button {
    padding: 0;
    width: 56px;
    height: 56px;
    background-color: transparent;
    border: none;
    &.home-pc {
      width: 70px;
      height: 70px;
    }
    &.match-tab {
      width: 40px;
      height: 40px;
    }
  }
  .ranking-event-icon {
    width: 56px;
    height: 56px;
    &.home-pc {
      width: 70px;
      height: 70px;
    }
    &.match-tab {
      width: 40px;
      height: 40px;
    }
  }
`

export const RankingPopupContent = styled.div`
  .ranking-image {
    display: block;
    width: 100%;
  }
  .ranking-event {
    padding: 0 14px 50px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    &--header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 9px;
      padding: 29px 14px 20px 14px;
      margin: 0 -14px;
      background: linear-gradient(180deg, #161428 0%, #1B202C 100%);
      .title-wrap {
        display: flex;
        order: 2;
        flex-direction: column;
        gap: 2px;
        align-items: center;
        justify-content: center;
      }
      .date-range-button {
        width: 40px;
        height: 40px;
        border: none;
        background-color: transparent;
        &::before {
          content: '';
          display: block;
          width: 16px;
          height: 16px;
          border-top: 2px solid ${props => props.theme.color.themeTxt};
          border-left: 2px solid ${props => props.theme.color.themeTxt};
        }
        &:disabled {
          opacity: 0.2;
        }
        &.prev-button {
          order: 1;
          &::before {
            margin-left: 10px;
            transform: rotate(-45deg);
          }
        }
        &.next-button {
          order: 3;
          &::before {
            margin-left: 2px;
            transform: rotate(135deg);
          }
        }
      }
    }
    &--title {
      font-size: ${props => props.theme.font.largeNum};
      font-weight: ${props => props.theme.fontW.bold};
      color: ${props => props.theme.color.white};
      text-align: center;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
    &--date-range {
      font-family: "Roboto", "Noto", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.disableTxt2};
      text-align: center;
    }
    
    .my-ranking {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 52px;
      margin-top: 9px;
      border-radius: 10px;
      background-color: ${props => props.theme.color.themeTxt};
      &--left-section {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        min-width: 0;
      }
      &--rank {
        display: inline-block;
        width: 54px;
        font-family: "Roboto", "Noto", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
        font-weight: ${props => props.theme.fontW.bold};
        font-size: ${props => props.theme.font.large};
        text-align: center;
        color: ${props => props.theme.color.modalTxt};
        flex-shrink: 0;
      }
      &--score {
        flex-shrink: 0;
        margin-right: 18px;
        font-family: "Roboto", "Noto", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
        font-weight: ${props => props.theme.fontW.bold};
        font-size: ${props => props.theme.font.large};
        text-align: center;
        color: ${props => props.theme.color.modalTxt};
      }
      &--profile {
        display: inline-block;
        width: 34px;
        height: 34px;
        margin-left: 4px;
        overflow: hidden;
        border-radius: 100px;
        flex-shrink: 0;
        .profile-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      &--nick {
        ${TxtLimit};
        min-width: 0;
        margin-left: 10px;
        font-size: ${props => props.theme.font.medium};
        font-weight: ${props => props.theme.fontW.bold};
        color: ${props => props.theme.color.modalTxt};
      }
    }
    
    &--info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 14px;
      .ranking-list-notice {
        font-weight: ${props => props.theme.fontW.medium};
        font-size: ${props => props.theme.font.medium};
        color: ${props => props.theme.color.btn};
      }
      .score-calculator-button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        background-color: transparent;
        font-weight: ${props => props.theme.fontW.medium};
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.modalBg};
        &--icon {
          width: 15px;
          height: 15px;
        }
      }
    }
  }

  .ranking-list {
    width: 100%;
    padding: 14px 9px;
    border-radius: 10px;
    background-color: ${props => props.theme.color.subColor};
    &.empty {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 400px;
    }
    &--empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .empty-title {
        font-weight: ${props => props.theme.fontW.bold};
        font-size: ${props => props.theme.font.title};
        color: ${props => props.theme.color.themeTxt};
      }
      .empty-desc {
        margin-top: 4px;
        font-weight: ${props => props.theme.fontW.medium};
        font-size: ${props => props.theme.font.medium};
        color: ${props => props.theme.color.disableTxt2};
      }
      .empty-icon {
        width: 134px;
        margin-bottom: 7px;
      }
    }
    &--wrap {
      .am-list {
        width: 100%;
      }
      .am-list-body {
        background-color: transparent;
      }
    }
  }
  .ranking-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 11px;
    height: 45px;
    padding: 0 10px 0 4px;
    &:last-child {
      margin-bottom: 0;
    }
    &--left-section {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      min-width: 0;
    }
    &--ranking {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 30px;
      font-family: "Roboto", "Noto", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.bold};
      color: ${props => props.theme.color.modalSubBg2};
      .ranking-number-icon {
        width: 30px;
        height: 30px;
      }
    }
    &--profile {
      margin: 0 10px 0 12px;
      width: 34px;
      height: 34px;
      border-radius: 100px;
      overflow: hidden;
      &.gold {
        border: 0.15rem solid #FFE824;
      }
      &.silver {
        border: 0.15rem solid #C6CCD1;
      }
      &.bronze {
        border: 0.15rem solid #C96F54;
      }
      .profile-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &--name {
      min-width: 0;
      flex: 1;
      ${TxtLimit};
      font-size: ${props => props.theme.font.medium};
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.themeTxt};
    }
    &--score {
      margin-left: 8px;
      flex-shrink: 0;
      font-family: "Roboto", "Noto", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.bold};
      color: ${props => props.theme.color.themeTxt};
    }
  }
  
  .ranking-event-info {
    border-top: 1px solid rgba(255, 255, 255, 0.015);
  }
  
  .notes {
    background-color: #141621;
    padding: 40px 35px 110px 24px;
    &--title {
      font-size: ${props => props.theme.font.large};
      font-weight: ${props => props.theme.fontW.bold};
      color: #dfdfdf;
      padding-bottom: 6px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.03);
    }
    &--list {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 12px;
    }
    &--item {
      position: relative;
      padding-left: 1em;
      font-size: 13px;
      font-weight: ${props => props.theme.fontW.medium};
      color: #adadad;
      &::before {
        content: "- ";
        position: absolute;
        left: 0;
      }
    }
  }
`
